/* AllureHaul merchandising metadata. Prices and inventory load from Shopify.
 * discover = cosmetic browsing placement; not a medical or efficacy certification.
 * Existing IDs are stable. Optional allurehaul.discovery metafields can override records.
 */
window.AHMerchandising = {
  "version": "shopify-1.0.1",
  "areas": [
    {
      "id": "face",
      "name": "Face",
      "note": "Texture, sculpting, lips + neck"
    },
    {
      "id": "eyes",
      "name": "Eyes",
      "note": "Dark under-eyes + puffiness"
    },
    {
      "id": "body",
      "name": "Body",
      "note": "Tone, recovery + body care"
    },
    {
      "id": "hair",
      "name": "Hair + Scalp",
      "note": "Growth, strength + styling"
    },
    {
      "id": "essentials",
      "name": "Beauty Essentials",
      "note": "The supporting routine"
    }
  ],
  "goals": [
    {
      "id": "glow",
      "name": "Glow + Smooth",
      "note": "A fresh start for your skin.",
      "product": "hydrallure"
    },
    {
      "id": "lift",
      "name": "Lift + Sculpt",
      "note": "Explore your contour-care routine.",
      "product": "precision"
    },
    {
      "id": "clear",
      "name": "Clear + Refine",
      "note": "Give cleansing a little more intention.",
      "product": "porebrush"
    },
    {
      "id": "depuff",
      "name": "Depuff + Brighten",
      "note": "A moment for your eye-care ritual.",
      "product": "luxeyes"
    },
    {
      "id": "style",
      "name": "Style + Shine",
      "note": "Make a good hair day your own.",
      "product": "versastyle"
    },
    {
      "id": "restore",
      "name": "Strengthen + Restore",
      "note": "Start with a considered scalp routine.",
      "product": "mane"
    }
  ],
  "concerns": [
    {
      "id": "face-texture",
      "area": "face",
      "name": "Skin texture",
      "goals": [
        "glow"
      ],
      "note": "Exfoliation and surface-care options."
    },
    {
      "id": "face-clarity",
      "area": "face",
      "name": "Clarity",
      "goals": [
        "clear"
      ],
      "note": "Cosmetic clarity and a refined-looking complexion—not active acne treatment."
    },
    {
      "id": "face-acne",
      "area": "face",
      "name": "Acne",
      "goals": [
        "clear"
      ],
      "note": "Blemish-care and cleansing options; not a diagnosis or treatment plan."
    },
    {
      "id": "face-scars",
      "area": "face",
      "name": "Scars",
      "goals": [
        "glow"
      ],
      "note": "Scar-related listings require product-specific evidence."
    },
    {
      "id": "face-pigmentation",
      "area": "face",
      "name": "Pigmentation / Skin tone",
      "goals": [
        "glow"
      ],
      "note": "Uneven-tone browsing. Category placement does not confirm treatment of pigmentation."
    },
    {
      "id": "face-puffiness",
      "area": "face",
      "name": "Facial puffiness",
      "goals": [
        "depuff"
      ],
      "note": "Facial massage and cooling tools, where linked."
    },
    {
      "id": "face-sculpting",
      "area": "face",
      "name": "Sculpting",
      "goals": [
        "lift"
      ],
      "note": "Facial microcurrent and massage devices."
    },
    {
      "id": "face-lines",
      "area": "face",
      "name": "Fine lines",
      "goals": [
        "glow"
      ],
      "note": "Line-care and facial massage options."
    },
    {
      "id": "face-lips",
      "area": "face",
      "name": "Lips",
      "goals": [
        "lift"
      ],
      "note": "Lip-specific tools, not eye-area devices."
    },
    {
      "id": "face-jaw",
      "area": "face",
      "name": "Jaw",
      "goals": [
        "lift"
      ],
      "note": "Jawline and facial massage options, not TMJ treatment."
    },
    {
      "id": "face-neck",
      "area": "face",
      "name": "Neck",
      "goals": [
        "lift"
      ],
      "note": "Neck-specific tools and posture companions; intended zones matter."
    },
    {
      "id": "eyes-dark",
      "area": "eyes",
      "name": "Dark under-eyes",
      "goals": [
        "depuff"
      ],
      "note": "Under-eye-specific listings; not permission for eyelid use."
    },
    {
      "id": "eyes-puffiness",
      "area": "eyes",
      "name": "Upper eye puffiness",
      "goals": [
        "depuff"
      ],
      "note": "Upper-eyelid use needs explicit product authorization."
    },
    {
      "id": "body-muscle",
      "area": "body",
      "name": "Build muscle",
      "goals": [
        "lift"
      ],
      "note": "EMS muscle-stimulation options; not a replacement for exercise."
    },
    {
      "id": "body-tone",
      "area": "body",
      "name": "Tone",
      "goals": [
        "lift"
      ],
      "note": "Body-contouring listings, distinct from weight loss."
    },
    {
      "id": "body-fat",
      "area": "body",
      "name": "Fat loss",
      "goals": [
        "lift"
      ],
      "note": "A weight-management goal. Contouring is not weight loss."
    },
    {
      "id": "body-recovery",
      "area": "body",
      "name": "Recovery",
      "goals": [
        "restore"
      ],
      "note": "Body comfort, rest and recovery tools."
    },
    {
      "id": "body-lymphatic",
      "area": "body",
      "name": "Lymphatic drainage",
      "goals": [
        "depuff"
      ],
      "note": "Do not treat unexplained swelling from a shopping quiz."
    },
    {
      "id": "body-fascia",
      "area": "body",
      "name": "Release fascia",
      "goals": [
        "restore"
      ],
      "note": "Massage and tissue-comfort tools; fascia-release claims need evidence."
    },
    {
      "id": "hair-growth",
      "area": "hair",
      "name": "Grow & strengthen",
      "goals": [
        "restore"
      ],
      "note": "Scalp-care and hair-growth-device listings."
    },
    {
      "id": "hair-styling",
      "area": "hair",
      "name": "Hair styling tools",
      "goals": [
        "style"
      ],
      "note": "Hot tools, brushes and cordless styling options."
    }
  ],
  "products": [
    {
      "id": "hydrallure",
      "handle": "hydrallure",
      "name": "HydrAllure",
      "originalTitle": "HydrAllure at Home HydraFacial",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "glow",
        "clear"
      ],
      "concernLinks": [
        {
          "concern": "face-texture",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "Water-assisted facial cleansing, not a resurfacing procedure.",
          "role": "tool"
        },
        {
          "concern": "face-acne",
          "area": "face",
          "goals": [
            "clear"
          ],
          "status": "discover",
          "note": "Cleansing support only. Avoid use over inflamed lesions unless the manual and clinician permit it.",
          "role": "support"
        },
        {
          "concern": "face-pigmentation",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "review",
          "note": "Cleansing is not evidence of pigment treatment. This requested association needs substantiation.",
          "role": "tool"
        }
      ],
      "technology": "Water-assisted suction cleansing",
      "description": "A water-assisted facial-cleansing device for a more considered at-home routine.",
      "notice": "The listing says to keep the tip moving, rather than lingering in one area, to avoid discoloration. Sensitivity compatibility is unverified.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": "The one we’d buy",
      "bestSellerCollection": true,
      "reviewStatus": "draft",
      "why": "A focused water-assisted cleansing option for a considered facial routine."
    },
    {
      "id": "precision",
      "handle": "precision-microcurrent-ems-beauty-enhancer",
      "name": "Precision MicroCurrent",
      "originalTitle": "Precision MicroCurrent EMS Beauty Enhancer",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "lift",
        "glow"
      ],
      "concernLinks": [
        {
          "concern": "face-sculpting",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Facial sculpting/massage placement based on the merchant description, not measured outcomes.",
          "role": "tool"
        },
        {
          "concern": "face-lines",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "A facial line-care browsing option; no promise of wrinkle reduction.",
          "role": "tool"
        },
        {
          "concern": "face-jaw",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Facial/jawline cosmetic placement, not treatment for jaw pain or TMJ dysfunction.",
          "role": "tool"
        }
      ],
      "technology": "EMS, RF and LED (listing description)",
      "description": "A multi-mode facial device to explore when you prefer one tool over a shelf of separate devices.",
      "notice": "Electrical-device precautions and the intended use of each mode need verification. No lifting or collagen outcome is guaranteed.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [
        "Precision Microcurrent EMS Beauty Enhancer"
      ],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "Several listed modes in one compact facial tool."
    },
    {
      "id": "versastyle",
      "handle": "5-in-1-multi-hairstyler",
      "name": "VersaStyle Pro",
      "originalTitle": "VersaStyle Pro 5 in 1 Multi Hairstyler",
      "areas": [
        "hair"
      ],
      "primaryAreas": [
        "hair"
      ],
      "goals": [
        "style"
      ],
      "concernLinks": [
        {
          "concern": "hair-styling",
          "area": "hair",
          "goals": [
            "style"
          ],
          "status": "discover",
          "note": "Hair styling format, not a scalp-growth treatment.",
          "role": "tool"
        }
      ],
      "technology": "5-in-1 hot-air styling",
      "description": "A multi-attachment hot-air styler for changing the shape of your everyday hair routine.",
      "notice": "Check the supplied plug, voltage and heat guidance. Time varies with hair length, texture and desired style.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [
        "VersaPro Styling Wand",
        "VersaStyle Pro"
      ],
      "edit": "Best under $100",
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "Five styling attachments at a comparatively accessible price."
    },
    {
      "id": "luxeyes",
      "handle": "3d-eye-beauty-instrument-micro-current-pulse-eye-relax-reduce-wrinkles-and-dark-circle-remove-eye-bags-massager-beauty-tool",
      "name": "LuxEyes Revive",
      "originalTitle": "LuxEyes Revive: 3D Micro-Current Pulse Dark Circle Eraser",
      "areas": [
        "eyes"
      ],
      "primaryAreas": [
        "eyes"
      ],
      "goals": [
        "depuff"
      ],
      "concernLinks": [
        {
          "concern": "eyes-dark",
          "area": "eyes",
          "goals": [
            "depuff"
          ],
          "status": "discover",
          "note": "An under-eye-specific merchant listing. Not authorization for the eyeball or upper eyelid.",
          "role": "tool"
        }
      ],
      "technology": "Eye-area microcurrent massage",
      "description": "A compact eye-area device, considered here for an eye-care ritual—not a guaranteed dark-circle correction.",
      "notice": "Eye-area use and electrical precautions need manual review. This category does not imply that the device is intended for lips.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": true,
      "reviewStatus": "draft",
      "why": "An eye-focused format with a five-minute session described by the listing."
    },
    {
      "id": "mane",
      "handle": "phototherapy-hairdressing-massage-comb-ems-micro-current-stimulation",
      "name": "ManeMaintain Pro",
      "originalTitle": "ManeMaintain Pro Brush: Phototherapy Hair Revitalizer",
      "areas": [
        "hair"
      ],
      "primaryAreas": [
        "hair"
      ],
      "goals": [
        "restore"
      ],
      "concernLinks": [
        {
          "concern": "hair-growth",
          "area": "hair",
          "goals": [
            "restore"
          ],
          "status": "discover",
          "note": "Scalp-care/light-device category. Product-specific growth outcomes not independently validated.",
          "role": "tool"
        }
      ],
      "technology": "Scalp brush with listed LED / EMS modes",
      "description": "A powered scalp brush. Strengthen + Restore is a shopping category here, not a promise of hair regrowth.",
      "notice": "Hair-growth results and electrical-device suitability have not been independently verified. Review the product manual before use.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A scalp-focused format for someone who enjoys a dedicated scalp-care ritual."
    },
    {
      "id": "flextrim",
      "handle": "flextrim-pro-ems-abdominal-body-slimming-belt",
      "name": "FlexTrim Pro",
      "originalTitle": "FlexTrim Pro: Smart EMS Abdominal Toner & Body Slimming Belt",
      "areas": [
        "body"
      ],
      "primaryAreas": [
        "body"
      ],
      "goals": [
        "lift"
      ],
      "concernLinks": [
        {
          "concern": "body-muscle",
          "area": "body",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "EMS muscle stimulation only; not a guarantee of muscle gain or replacement for exercise.",
          "role": "tool"
        },
        {
          "concern": "body-tone",
          "area": "body",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "EMS muscle-tone category; not weight or fat loss.",
          "role": "tool"
        }
      ],
      "technology": "EMS body belt",
      "description": "An electrical muscle-stimulation belt from the existing catalog.",
      "notice": "Automatic recommendations are on hold pending intended-use and safety documentation. It is not presented here as a weight-loss or fat-loss tool.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": true,
      "reviewStatus": "draft",
      "why": "A body-device listing retained for comparison, pending intended-use review."
    },
    {
      "id": "frixie",
      "handle": "high-frequency-electrotherapy-wand-42833",
      "name": "Frixie ProBeam",
      "originalTitle": "Frixie ProBeam High Frequency Wand",
      "areas": [
        "face",
        "eyes",
        "body",
        "hair"
      ],
      "primaryAreas": [
        "face",
        "hair"
      ],
      "goals": [
        "glow",
        "clear",
        "depuff",
        "restore"
      ],
      "concernLinks": [
        {
          "concern": "face-texture",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "Merchant positions this wand for facial skincare. Efficacy and model-specific compatibility are unverified.",
          "role": "tool"
        },
        {
          "concern": "face-acne",
          "area": "face",
          "goals": [
            "clear"
          ],
          "status": "discover",
          "note": "Merchant positions this wand for facial skincare. Efficacy and model-specific compatibility are unverified.",
          "role": "tool"
        },
        {
          "concern": "face-scars",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "review",
          "note": "No adequate model-specific support was established for this requested concern/site. Facial/scalp marketing does not authorize eye or lymphatic use.",
          "role": "tool"
        },
        {
          "concern": "face-pigmentation",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "review",
          "note": "No adequate model-specific support was established for this requested concern/site. Facial/scalp marketing does not authorize eye or lymphatic use.",
          "role": "tool"
        },
        {
          "concern": "eyes-dark",
          "area": "eyes",
          "goals": [
            "depuff"
          ],
          "status": "review",
          "note": "No adequate model-specific support was established for this requested concern/site. Facial/scalp marketing does not authorize eye or lymphatic use.",
          "role": "tool"
        },
        {
          "concern": "body-lymphatic",
          "area": "body",
          "goals": [
            "depuff"
          ],
          "status": "review",
          "note": "No adequate model-specific support was established for this requested concern/site. Facial/scalp marketing does not authorize eye or lymphatic use.",
          "role": "tool"
        },
        {
          "concern": "hair-growth",
          "area": "hair",
          "goals": [
            "restore"
          ],
          "status": "discover",
          "note": "Scalp-care placement from the merchant comb-electrode description; not proven hair regrowth.",
          "role": "tool"
        }
      ],
      "technology": "High-frequency glass-electrode wand",
      "description": "A high-frequency wand with interchangeable glass attachments.",
      "notice": "Automatic recommendations are on hold while intended areas, electrical precautions and claim evidence are reviewed. No acne-treatment claim is endorsed.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [
        "High frequency wand",
        "Frixie ProBeam High Frequency Wand"
      ],
      "edit": null,
      "bestSellerCollection": true,
      "reviewStatus": "draft",
      "why": "An established catalog listing that needs clearer device-specific evidence."
    },
    {
      "id": "imask",
      "handle": "imask-eye-brightening-dark-circle-enhancer",
      "name": "iMask",
      "originalTitle": "iMask Eye Brightening Enhancer",
      "areas": [
        "eyes"
      ],
      "primaryAreas": [
        "eyes"
      ],
      "goals": [
        "depuff"
      ],
      "concernLinks": [
        {
          "concern": "eyes-dark",
          "area": "eyes",
          "goals": [
            "depuff"
          ],
          "status": "discover",
          "note": "An under-eye-specific merchant listing. Not authorization for the eyeball or upper eyelid.",
          "role": "tool"
        }
      ],
      "technology": "Eye-area device with listed LED / EMS modes",
      "description": "A compact paired eye-area device with a storage case.",
      "notice": "Eye-area compatibility and electrical precautions require manual review. “Innovation to explore” does not mean newly launched, independently tested or proven.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": "Innovation to explore",
      "bestSellerCollection": true,
      "reviewStatus": "draft",
      "why": "A distinctive eye-care format to compare with a simpler wand."
    },
    {
      "id": "volumallure",
      "handle": "hot-air-hair-dryer-brush-volumizer",
      "name": "VolumAllure",
      "originalTitle": "VolumAllure Heated Blow Out Brush",
      "areas": [
        "hair"
      ],
      "primaryAreas": [
        "hair"
      ],
      "goals": [
        "style"
      ],
      "concernLinks": [
        {
          "concern": "hair-styling",
          "area": "hair",
          "goals": [
            "style"
          ],
          "status": "discover",
          "note": "Hair styling format, not a scalp-growth treatment.",
          "role": "tool"
        }
      ],
      "technology": "Hot-air brush",
      "description": "A heated blow-out brush for shoppers who prefer a familiar styling shape.",
      "notice": "Choose the appropriate plug and check voltage. Heat and styling time depend on hair and the manufacturer’s instructions.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": true,
      "reviewStatus": "draft",
      "why": "A straightforward brush-and-air format under $40 in the catalog snapshot."
    },
    {
      "id": "ipl",
      "handle": "990000-flash-professional-permanent-ipl-epilator-laser-81918",
      "name": "IPL Hair Allureminator",
      "originalTitle": "IPL Hair Allureminator Device",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "glow"
      ],
      "concernLinks": [
        {
          "concern": "face-pigmentation",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "review",
          "note": "This listing is a hair-removal IPL device. It must not be substituted for an approved pigmentation treatment.",
          "role": "tool"
        }
      ],
      "technology": "Intense pulsed light (IPL)",
      "description": "An IPL hair-removal device retained in the body catalog, not automatically matched by this five-question flow.",
      "notice": "Automatic recommendations are on hold. Skin-tone, hair-color, treatment-area and product-specific safety checks are missing from this five-question matcher.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": true,
      "reviewStatus": "draft",
      "why": "A hair-removal listing that requires its own compatibility screening."
    },
    {
      "id": "lipo",
      "handle": "ultrasound-cavitation-ems-body-slimming-massager-weight-loss-lipo-fat-burner-galvanic-infrared-ultrasonic-therapy-slim-machine-34573",
      "name": "LipoAllure",
      "originalTitle": "LipoAllure Cavitation EMS Machine",
      "areas": [
        "body"
      ],
      "primaryAreas": [
        "body"
      ],
      "goals": [
        "lift"
      ],
      "concernLinks": [
        {
          "concern": "body-tone",
          "area": "body",
          "goals": [
            "lift"
          ],
          "status": "review",
          "note": "Body contour listing retained for review. Actual modality, contraindications and effect evidence must be confirmed.",
          "role": "tool"
        },
        {
          "concern": "body-fat",
          "area": "body",
          "goals": [
            "lift"
          ],
          "status": "review",
          "note": "No weight-loss benefit is established. Contouring and EMS must not be sold as substitutes for weight management.",
          "role": "tool"
        }
      ],
      "technology": "Listing describes ultrasound / EMS",
      "description": "A handheld body device from the current catalog.",
      "notice": "Automatic recommendations are on hold pending device documentation and claim review. The preview does not endorse weight loss, fat burning or girth reduction.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": true,
      "reviewStatus": "draft",
      "why": "A legacy body-device listing that needs substantiation before recommendation."
    },
    {
      "id": "vitalheal",
      "handle": "red-light-therapy-wand-device-1",
      "name": "VitalHeal Pro",
      "originalTitle": "VitalHeal Pro: Red Light Therapy Wand",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "glow"
      ],
      "concernLinks": [
        {
          "concern": "face-lines",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "review",
          "note": "The generic light-wand listing needs model-specific wavelength, eye-safety and efficacy review.",
          "role": "tool"
        }
      ],
      "technology": "Red-light wand (merchant description)",
      "description": "A red-light wand listed in the current facial collection.",
      "notice": "Automatic recommendations are on hold: intended treatment areas, cosmetic use and safety instructions have not been verified. Store collection placement is not proof of suitability.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A catalog item to investigate—not a verified cosmetic facial recommendation."
    },
    {
      "id": "ledmask",
      "handle": "led-facial-beauty-instrument",
      "name": "LED Facial Beauty Instrument",
      "originalTitle": "Led Facial beauty instrument",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "glow",
        "clear"
      ],
      "concernLinks": [
        {
          "concern": "face-texture",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "Facial LED listing; exact mode, eye protection and intended-use evidence must be checked.",
          "role": "tool"
        },
        {
          "concern": "face-acne",
          "area": "face",
          "goals": [
            "clear"
          ],
          "status": "discover",
          "note": "Facial LED listing; exact mode, eye protection and intended-use evidence must be checked.",
          "role": "tool"
        },
        {
          "concern": "face-scars",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "review",
          "note": "A general facial LED listing does not establish this specific treatment outcome.",
          "role": "tool"
        },
        {
          "concern": "face-pigmentation",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "review",
          "note": "A general facial LED listing does not establish this specific treatment outcome.",
          "role": "tool"
        }
      ],
      "technology": "LED face mask",
      "description": "An LED facial mask from the existing device collection.",
      "notice": "Automatic recommendations are on hold pending verification of eye protection, instructions, light specifications and supported claims.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [
        "Red light mask"
      ],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A hands-free format to review once technical and safety details are complete."
    },
    {
      "id": "lipenhance",
      "handle": "electric-lip-enhancer",
      "name": "LipEnhance",
      "originalTitle": "LipEnhance Electric Lip Plumper",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "lift"
      ],
      "concernLinks": [
        {
          "concern": "face-lips",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Lip-specific device. Review suction settings and contraindications in the actual manual.",
          "role": "tool"
        }
      ],
      "technology": "Electric lip-suction device",
      "description": "An electric lip-enhancement tool listed by the store.",
      "notice": "Automatic recommendations are on hold pending lip-suction instructions and safety review. The eye-area devices in this category are not interchangeable with lip tools.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A lip-specific listing, kept separate from eye devices."
    },
    {
      "id": "luxulift",
      "handle": "luxulift-roller-ems-infused-facial-sphere-microcurrent-massage-ball",
      "name": "LuxuLift Roller",
      "originalTitle": "LuxuLift Roller: EMS Infused Facial Sphere",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "lift"
      ],
      "concernLinks": [
        {
          "concern": "face-sculpting",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Facial sculpting/massage placement based on the merchant description, not measured outcomes.",
          "role": "tool"
        },
        {
          "concern": "face-jaw",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Facial/jawline cosmetic placement, not treatment for jaw pain or TMJ dysfunction.",
          "role": "tool"
        }
      ],
      "technology": "Facial roller with listed EMS mode",
      "description": "A facial massage roller with an electrical mode described by the listing.",
      "notice": "Electrical precautions and sensitivity suitability are unverified. No permanent lifting or contour change is promised.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [
        "LuxuLift EMS Infused Facial Sphere"
      ],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A compact roller format at an accessible price."
    },
    {
      "id": "allurionic",
      "handle": "allure-ionic-cordless-rechargeable-hair-dryer",
      "name": "Allurionic",
      "originalTitle": "Allurionic Cordless & Rechargeable Hair Dryer",
      "areas": [
        "hair"
      ],
      "primaryAreas": [
        "hair"
      ],
      "goals": [
        "style"
      ],
      "concernLinks": [
        {
          "concern": "hair-styling",
          "area": "hair",
          "goals": [
            "style"
          ],
          "status": "discover",
          "note": "Hair styling format, not a scalp-growth treatment.",
          "role": "tool"
        }
      ],
      "technology": "Cordless rechargeable hair dryer",
      "description": "The higher-priced cordless hair dryer in this starter catalog.",
      "notice": "Battery runtime, heat performance, voltage and travel requirements need confirmation. “Worth the splurge” is a draft editorial placement, not a test verdict.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": true,
      "cordlessEvidence": "The existing product listing explicitly describes cordless operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": "Worth the splurge",
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A cordless format for shoppers who value freedom from an outlet."
    },
    {
      "id": "flatiron",
      "handle": "cordless-flat-iron",
      "name": "Cordless Flat Iron",
      "originalTitle": "Cordless Flat Iron Styler",
      "areas": [
        "hair"
      ],
      "primaryAreas": [
        "hair"
      ],
      "goals": [
        "style"
      ],
      "concernLinks": [
        {
          "concern": "hair-styling",
          "area": "hair",
          "goals": [
            "style"
          ],
          "status": "discover",
          "note": "Hair styling format, not a scalp-growth treatment.",
          "role": "tool"
        }
      ],
      "technology": "Cordless heated styling plates",
      "description": "A rechargeable flat iron for a portable styling routine.",
      "notice": "The two-minute estimate covers small touch-ups, not full-head styling. Verify heat, charging and travel guidance.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": true,
      "cordlessEvidence": "The existing product listing explicitly describes cordless operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [
        "Cordless Flat iron"
      ],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A compact format for small styling touch-ups rather than a full blow-out."
    },
    {
      "id": "claymask",
      "handle": "two-color-clay-mask-cleansing-pores-moisturizing",
      "name": "Two-Color Clay Mask",
      "originalTitle": "Two-color Clay Mask Cleansing Pores Moisturizing",
      "areas": [
        "essentials"
      ],
      "primaryAreas": [
        "essentials"
      ],
      "goals": [],
      "concernLinks": [],
      "technology": "Topical clay mask • not a device",
      "description": "A two-part clay-mask product kept in Beauty Essentials.",
      "notice": "Ingredient compatibility and frequency require verification. This is not automatically suggested for the same session as a suction or exfoliating tool.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "companion",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A separate skincare companion, never substituted for a device match."
    },
    {
      "id": "sonicbrush",
      "handle": "ultrasonic-electric-facial-cleansing-brush",
      "name": "Ultrasonic Cleansing Brush",
      "originalTitle": "Ultrasonic Electric Facial Cleansing Brush",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "clear",
        "glow"
      ],
      "concernLinks": [
        {
          "concern": "face-acne",
          "area": "face",
          "goals": [
            "clear"
          ],
          "status": "discover",
          "note": "Cleansing companion, not treatment of active inflamed acne.",
          "role": "support"
        },
        {
          "concern": "face-texture",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "Cleansing support for a surface-care routine.",
          "role": "support"
        }
      ],
      "technology": "Silicone powered cleansing brush",
      "description": "A handheld silicone cleansing brush from the current facial collection.",
      "notice": "The listing mentions both one- and two-minute routines. Confirm the actual manual; “silicone” does not establish sensitivity compatibility.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [
        "Silicone cleansing device"
      ],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A simple, lower-priced cleansing format for a short routine."
    },
    {
      "id": "porebrush",
      "handle": "5-in-1-electric-pore-facial-cleansing-brush",
      "name": "Pore Revitalizing Brush",
      "originalTitle": "Electric Pore Revitalizing Cleansing Brush",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "clear",
        "glow"
      ],
      "concernLinks": [
        {
          "concern": "face-acne",
          "area": "face",
          "goals": [
            "clear"
          ],
          "status": "discover",
          "note": "Cleansing companion, not treatment of active inflamed acne.",
          "role": "support"
        },
        {
          "concern": "face-texture",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "Cleansing support for a surface-care routine.",
          "role": "support"
        }
      ],
      "technology": "Powered brush with five attachments",
      "description": "A powered facial-cleansing brush with interchangeable attachments and two listed speeds.",
      "notice": "Do not treat the listing’s “all skin types” wording as a verified sensitivity recommendation. Match the attachment and use to the manufacturer’s instructions.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "Multiple cleansing attachments without a premium entry price."
    },
    {
      "id": "eyeregen",
      "handle": "magic-eye-wand-11619",
      "name": "EyeRegen",
      "originalTitle": "EyeRegen Brightening Wand",
      "areas": [
        "eyes"
      ],
      "primaryAreas": [
        "eyes"
      ],
      "goals": [
        "depuff"
      ],
      "concernLinks": [
        {
          "concern": "eyes-dark",
          "area": "eyes",
          "goals": [
            "depuff"
          ],
          "status": "discover",
          "note": "An under-eye-specific merchant listing. Not authorization for the eyeball or upper eyelid.",
          "role": "tool"
        }
      ],
      "technology": "Battery-powered eye-area massage wand",
      "description": "A compact wand with a contact-activated massage head described by the listing.",
      "notice": "The source mixes eye-care and unrelated treatment claims. Automatic recommendations are on hold until its intended use and instructions are clarified.",
      "frequency": "Follow the product manual; frequency has not been verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing. USB power alone is not proof of battery operation.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A low-entry-price eye-area format; the listing still needs a claims cleanup."
    },
    {
      "id": "celestialuxe",
      "handle": "celestialuxe-custom-elixir-infusion",
      "name": "CelestiaLuxe Custom Elixir Infusion",
      "originalTitle": "CelestiaLuxe Custom Elixir Infusion",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "lift",
        "glow"
      ],
      "concernLinks": [
        {
          "concern": "face-sculpting",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Facial sculpting/massage placement based on the merchant description, not measured outcomes.",
          "role": "tool"
        },
        {
          "concern": "face-lines",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "A facial line-care browsing option; no promise of wrinkle reduction.",
          "role": "tool"
        }
      ],
      "technology": "Hot/cool facial massager · multiple modes",
      "description": "A facial massage tool listed with hot and cool modes and adjustable settings.",
      "notice": "Merchant descriptions have not been independently validated. Confirm intended use and compatibility before purchase.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "facesculpt",
      "handle": "7-in-1-face-lift-device-facial-massager",
      "name": "FaceSculpt 7-in-1 Elegance Enhancer",
      "originalTitle": "FaceSculpt 7-in-1 Elegance Enhancer",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "lift",
        "glow"
      ],
      "concernLinks": [
        {
          "concern": "face-sculpting",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Facial sculpting/massage placement based on the merchant description, not measured outcomes.",
          "role": "tool"
        },
        {
          "concern": "face-lines",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "A facial line-care browsing option; no promise of wrinkle reduction.",
          "role": "tool"
        }
      ],
      "technology": "Multi-mode facial massage",
      "description": "A facial device marketed for a multi-mode sculpting and line-care routine.",
      "notice": "Merchant descriptions have not been independently validated. Confirm intended use and compatibility before purchase.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "redradiance",
      "handle": "home-collagen-gun-beauty-portable-ems-red-light-instrument",
      "name": "RedRadiance EMS Collagen Beauty Gun",
      "originalTitle": "RedRadiance EMS Collagen Beauty Gun",
      "areas": [
        "face",
        "eyes"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "lift",
        "glow",
        "depuff"
      ],
      "concernLinks": [
        {
          "concern": "face-sculpting",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Facial sculpting/massage placement based on the merchant description, not measured outcomes.",
          "role": "tool"
        },
        {
          "concern": "face-lines",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "A facial line-care browsing option; no promise of wrinkle reduction.",
          "role": "tool"
        },
        {
          "concern": "face-scars",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "review",
          "note": "Scar-treatment evidence and intended-use instructions were not established for this model.",
          "role": "tool"
        },
        {
          "concern": "eyes-puffiness",
          "area": "eyes",
          "goals": [
            "depuff"
          ],
          "status": "review",
          "note": "No explicit upper-eyelid safety authorization was established. Not included as an automatic upper-eye recommendation.",
          "role": "tool"
        }
      ],
      "technology": "Facial EMS / light device · technology review pending",
      "description": "A handheld facial device listed with EMS and red-light features. Exact technical specifications require confirmation.",
      "notice": "Facial positioning does not establish permission for the upper eyelid. Eye-area use and scar-treatment claims are held for review.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "eternasculpt",
      "handle": "eternasculpt-microcurrent-ipl-facial-lift",
      "name": "EternaSculpt MicroCurrent IPL Facial Lift",
      "originalTitle": "EternaSculpt MicroCurrent IPL Facial Lift",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "lift"
      ],
      "concernLinks": [
        {
          "concern": "face-sculpting",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Facial sculpting/massage placement based on the merchant description, not measured outcomes.",
          "role": "tool"
        },
        {
          "concern": "face-jaw",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Facial/jawline cosmetic placement, not treatment for jaw pain or TMJ dysfunction.",
          "role": "tool"
        }
      ],
      "technology": "Adjustable chin/jaw device · microcurrent and light modes",
      "description": "A folding chin/jaw device with adjustable settings and a listed rechargeable battery.",
      "notice": "The title says IPL, while the description lists red/blue light modes. Verify the actual technology. This is not interchangeable with a hair-removal IPL handset.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": true,
      "cordlessEvidence": "The product description lists a 1000mAh battery and folding portable design.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "dermallure",
      "handle": "dermallure-roller",
      "name": "DermAllure Roller",
      "originalTitle": "DermAllure Roller",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "glow",
        "clear"
      ],
      "concernLinks": [
        {
          "concern": "face-texture",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "Cosmetic texture / Glow + Smooth browsing placement. Not a guarantee of smoothing or a suitability assessment.",
          "role": "tool"
        },
        {
          "concern": "face-clarity",
          "area": "face",
          "goals": [
            "clear"
          ],
          "status": "discover",
          "role": "tool",
          "note": "Cosmetic clarity / Clear + Refine browsing placement only. Does not imply acne treatment, pore cleansing or use over inflamed skin."
        },
        {
          "concern": "face-scars",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "review",
          "note": "Skin rolling is not automatically appropriate for this concern. Active inflamed acne and eye-area use must not be recommended from this quiz.",
          "role": "tool"
        },
        {
          "concern": "face-pigmentation",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "Pigmentation / Skin tone browsing placement requested by the merchant. This does not confirm pigment reduction or validate this model for treatment.",
          "role": "tool"
        },
        {
          "concern": "face-acne",
          "area": "face",
          "goals": [
            "clear"
          ],
          "status": "review",
          "note": "Skin rolling is not automatically appropriate for this concern. Active inflamed acne and eye-area use must not be recommended from this quiz.",
          "role": "tool"
        },
        {
          "concern": "eyes-dark",
          "area": "eyes",
          "goals": [
            "depuff"
          ],
          "status": "review",
          "note": "Skin rolling is not automatically appropriate for this concern. Active inflamed acne and eye-area use must not be recommended from this quiz.",
          "role": "tool"
        }
      ],
      "technology": "Manual skin roller",
      "description": "A manually operated facial roller sold in two needle-length variants.",
      "notice": "At-home skin rolling can irritate or injure skin and carries infection and scarring risks. Do not use a quiz match as advice to roll over active inflamed acne or around the eyes. Needle-length suitability, intended use and product-specific performance have not been independently verified.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Manual tool; no electrical power.",
      "role": "manual",
      "blockedSale": false,
      "aliases": [
        "Dermarolling",
        "Dermaroller",
        "Derma roller",
        "Skin tone",
        "Clarity"
      ],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "Included in the cosmetic texture, tone and clarity edit at the merchant’s request. This is category organization, not a claim of verified results.",
      "catalogNote": "Cosmetic browsing only—not verified pigment treatment or active-acne care. Review the product instructions and skin suitability before use."
    },
    {
      "id": "eyeluxe",
      "handle": "eyefrequency-luxe-red-light-ems-rejuvenator-wand",
      "name": "EyeLuxe Frequency Wand",
      "originalTitle": "EyeLuxe Frequency Wand",
      "areas": [
        "eyes"
      ],
      "primaryAreas": [
        "eyes"
      ],
      "goals": [
        "depuff"
      ],
      "concernLinks": [
        {
          "concern": "eyes-dark",
          "area": "eyes",
          "goals": [
            "depuff"
          ],
          "status": "discover",
          "note": "An under-eye-specific merchant listing. Not authorization for the eyeball or upper eyelid.",
          "role": "tool"
        }
      ],
      "technology": "Under-eye EMS, warmth and red light",
      "description": "An eye-area wand listed with red light, EMS and warming features, plus battery-powered operation.",
      "notice": "Under-eye positioning is not permission to use on the eyeball or upper eyelid. Check the model-specific manual and eye-protection requirements.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": true,
      "cordlessEvidence": "The listing specifies a 500mAh battery and more than 90 minutes of working time.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "eclatpen",
      "handle": "eye-messager-rf-radio-mesotherapy-electroporation-beauty-pen-ems-frequency-led-face-lifitng-skin-rejuvenation-wrinkle-remover",
      "name": "EyeRevive EclatPen RF Mesotherapy",
      "originalTitle": "EyeRevive EclatPen RF Mesotherapy",
      "areas": [
        "face",
        "eyes"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "lift",
        "glow",
        "depuff"
      ],
      "concernLinks": [
        {
          "concern": "face-sculpting",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Facial sculpting/massage placement based on the merchant description, not measured outcomes.",
          "role": "tool"
        },
        {
          "concern": "face-lines",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "A facial line-care browsing option; no promise of wrinkle reduction.",
          "role": "tool"
        },
        {
          "concern": "face-scars",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "review",
          "note": "Scar-treatment evidence and intended-use instructions were not established for this model.",
          "role": "tool"
        },
        {
          "concern": "face-pigmentation",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "review",
          "note": "Pigmentation-specific labeling and evidence need review.",
          "role": "tool"
        },
        {
          "concern": "eyes-dark",
          "area": "eyes",
          "goals": [
            "depuff"
          ],
          "status": "review",
          "note": "Eye wording in the title does not establish safe RF/EMS placement, settings or eye protection. Manual review needed.",
          "role": "tool"
        }
      ],
      "technology": "RF / EMS / LED facial pen",
      "description": "The live listing corresponding to the requested RF Mesotherapy Electroporation EMS Pen.",
      "notice": "Specific scar, pigmentation and eye-area treatment claims require model-specific evidence and safety instructions. The listing title alone is not a safety assessment.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing.",
      "role": "device",
      "blockedSale": false,
      "aliases": [
        "RF Mesotherapy Electroporation EMS Pen",
        "RF Mesotherapy Electroporation Beauty Pen"
      ],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "glogrow",
      "handle": "glogrow-infrared-laser-hair-growth-comb",
      "name": "GloGrow Infrared Laser Hair Comb",
      "originalTitle": "GloGrow Infrared Laser Hair Comb",
      "areas": [
        "hair"
      ],
      "primaryAreas": [
        "hair"
      ],
      "goals": [
        "restore"
      ],
      "concernLinks": [
        {
          "concern": "hair-growth",
          "area": "hair",
          "goals": [
            "restore"
          ],
          "status": "discover",
          "note": "Scalp-care/light-device category. Product-specific growth outcomes not independently validated.",
          "role": "tool"
        }
      ],
      "technology": "Scalp comb · EMS and light modes",
      "description": "A scalp comb listed with EMS, laser/light and vibration features.",
      "notice": "Merchant descriptions have not been independently validated. Confirm intended use and compatibility before purchase.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": true,
      "cordlessEvidence": "The merchant specifies a 1000mAh battery, 100-minute working time and 90-minute charge.",
      "role": "device",
      "blockedSale": false,
      "aliases": [
        "GloGrow EMS Infrared Laser Hair Comb"
      ],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "spasteam",
      "handle": "ionic-facial-steamer",
      "name": "Ionic SpaSteam System",
      "originalTitle": "Ionic SpaSteam System",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "clear",
        "glow"
      ],
      "concernLinks": [
        {
          "concern": "face-acne",
          "area": "face",
          "goals": [
            "clear"
          ],
          "status": "discover",
          "note": "Cleansing companion, not treatment of active inflamed acne.",
          "role": "support"
        },
        {
          "concern": "face-texture",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "Cleansing support for a surface-care routine.",
          "role": "support"
        }
      ],
      "technology": "Facial steam · cleansing companion",
      "description": "A facial steamer for a cleansing routine; this listing does not establish that steam treats acne.",
      "notice": "Steam can irritate reactive skin. This is a cleansing companion, not an acne treatment or a detoxification claim.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "liposculpt",
      "handle": "electric-ems-beauty-hip-lifting-instrument-home-massage",
      "name": "LipoSculpt Laser Contour System",
      "originalTitle": "LipoSculpt Laser Contour System",
      "areas": [
        "body"
      ],
      "primaryAreas": [
        "body"
      ],
      "goals": [
        "lift"
      ],
      "concernLinks": [
        {
          "concern": "body-tone",
          "area": "body",
          "goals": [
            "lift"
          ],
          "status": "review",
          "note": "Body contour listing retained for review. Actual modality, contraindications and effect evidence must be confirmed.",
          "role": "tool"
        },
        {
          "concern": "body-fat",
          "area": "body",
          "goals": [
            "lift"
          ],
          "status": "review",
          "note": "No weight-loss benefit is established. Contouring and EMS must not be sold as substitutes for weight management.",
          "role": "tool"
        }
      ],
      "technology": "Body contour device · modality verification needed",
      "description": "A body-shaping listing whose laser title and EMS handle require technical reconciliation.",
      "notice": "The device modality and intended-use evidence need review. Body contouring must not be presented as weight loss.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "duobeam",
      "handle": "red-blue-light-therapy-pen-71008",
      "name": "RadianceRejuv DuoBeam Light Therapy Pen",
      "originalTitle": "RadianceRejuv DuoBeam Light Therapy Pen",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "clear"
      ],
      "concernLinks": [
        {
          "concern": "face-acne",
          "area": "face",
          "goals": [
            "clear"
          ],
          "status": "discover",
          "note": "The listing describes red/blue light blemish care; not independently validated.",
          "role": "tool"
        }
      ],
      "technology": "Red / blue light spot-care pen",
      "description": "A small battery-powered red/blue light pen listed for facial blemish-care routines.",
      "notice": "Confirm actual wavelengths, eye protection and the intended skin condition. No clinical efficacy has been independently verified for this listing.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": true,
      "cordlessEvidence": "The listing specifies dry-battery power; battery not included.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "slimsculpt",
      "handle": "body-slimming-machine",
      "name": "SlimSculpt Contour Pro",
      "originalTitle": "SlimSculpt Contour Pro",
      "areas": [
        "body"
      ],
      "primaryAreas": [
        "body"
      ],
      "goals": [
        "lift"
      ],
      "concernLinks": [
        {
          "concern": "body-tone",
          "area": "body",
          "goals": [
            "lift"
          ],
          "status": "review",
          "note": "Body contour listing retained for review. Actual modality, contraindications and effect evidence must be confirmed.",
          "role": "tool"
        },
        {
          "concern": "body-fat",
          "area": "body",
          "goals": [
            "lift"
          ],
          "status": "review",
          "note": "No weight-loss benefit is established. Contouring and EMS must not be sold as substitutes for weight management.",
          "role": "tool"
        }
      ],
      "technology": "Body cavitation / RF / light modes",
      "description": "A body-contouring device listed with several energy-based modes.",
      "notice": "Body contouring is not weight loss. Verify technical specifications, labeling, contraindications and model-specific evidence before recommending a treatment.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "smartfit",
      "handle": "smartfit-ems-glute-sculpting-leggings",
      "name": "SmartFit EMS Glute Sculpting Leggings",
      "originalTitle": "SmartFit EMS Glute Sculpting Leggings",
      "areas": [
        "body"
      ],
      "primaryAreas": [
        "body"
      ],
      "goals": [
        "lift"
      ],
      "concernLinks": [
        {
          "concern": "body-muscle",
          "area": "body",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "EMS muscle stimulation only; not a guarantee of muscle gain or replacement for exercise.",
          "role": "tool"
        },
        {
          "concern": "body-tone",
          "area": "body",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "EMS muscle-tone category; not weight or fat loss.",
          "role": "tool"
        }
      ],
      "technology": "Wearable EMS · glutes and thighs",
      "description": "Wearable EMS leggings listed for stimulation of glute and thigh muscles.",
      "notice": "EMS muscle stimulation is not a substitute for exercise and is not evidence of weight loss. Check the actual instructions and electrical-device contraindications.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "scraper",
      "handle": "ultrasonic-face-skin-scrubber-89784",
      "name": "Ultrasonic Pore Remover",
      "originalTitle": "Ultrasonic Pore Remover",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "glow"
      ],
      "concernLinks": [
        {
          "concern": "face-texture",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "Exfoliation/cleansing format relevant to surface texture.",
          "role": "tool"
        }
      ],
      "technology": "Ultrasonic skin scraper",
      "description": "A rechargeable stainless-steel skin scraper, distinct from a silicone cleansing brush.",
      "notice": "Merchant descriptions have not been independently validated. Confirm intended use and compatibility before purchase.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": true,
      "cordlessEvidence": "The listing gives a 3–5 hour charge and 1.5–2 hour working time.",
      "role": "device",
      "blockedSale": false,
      "aliases": [
        "Ultrasonic scraper"
      ],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "straightcomb",
      "handle": "straightening-comb-rechargeable-hair-wireless-straightener-curler-curling-straighten-dual-purpose-travel-portable-usb-charging",
      "name": "Rechargeable Straightening Comb",
      "originalTitle": "Rechargeable Straightening Comb",
      "areas": [
        "hair"
      ],
      "primaryAreas": [
        "hair"
      ],
      "goals": [
        "style"
      ],
      "concernLinks": [
        {
          "concern": "hair-styling",
          "area": "hair",
          "goals": [
            "style"
          ],
          "status": "discover",
          "note": "Hair styling format, not a scalp-growth treatment.",
          "role": "tool"
        }
      ],
      "technology": "Cordless heated straightening comb",
      "description": "A rechargeable heated comb for styling and touch-ups.",
      "notice": "Merchant descriptions have not been independently validated. Confirm intended use and compatibility before purchase.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": true,
      "cordlessEvidence": "The listing specifies wireless operation, a 4000mAh battery and approximately 40-minute working time.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "lumilift",
      "handle": "microglow%E2%84%A2%EF%B8%8F-handset-33008",
      "name": "LumiLift LED Microcurrent Facial Sculptor",
      "originalTitle": "LumiLift LED Microcurrent Facial Sculptor",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "lift",
        "glow"
      ],
      "concernLinks": [
        {
          "concern": "face-sculpting",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Facial sculpting/massage placement based on the merchant description, not measured outcomes.",
          "role": "tool"
        },
        {
          "concern": "face-lines",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "discover",
          "note": "A facial line-care browsing option; no promise of wrinkle reduction.",
          "role": "tool"
        }
      ],
      "technology": "Facial microcurrent and LED",
      "description": "A facial sculpting handset with listed microcurrent and light modes.",
      "notice": "Merchant descriptions have not been independently validated. Confirm intended use and compatibility before purchase.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "redbelt",
      "handle": "home-slimming-belt-led-heating-red-light-belt",
      "name": "Red Light Heated Belt",
      "originalTitle": "Red Light Heated Belt",
      "areas": [
        "body"
      ],
      "primaryAreas": [
        "body"
      ],
      "goals": [
        "lift"
      ],
      "concernLinks": [
        {
          "concern": "body-tone",
          "area": "body",
          "goals": [
            "lift"
          ],
          "status": "review",
          "note": "Body contour listing retained for review. Actual modality, contraindications and effect evidence must be confirmed.",
          "role": "tool"
        },
        {
          "concern": "body-fat",
          "area": "body",
          "goals": [
            "lift"
          ],
          "status": "review",
          "note": "No weight-loss benefit is established. Contouring and EMS must not be sold as substitutes for weight management.",
          "role": "tool"
        }
      ],
      "technology": "Body light / heated belt",
      "description": "A waist/abdomen light-belt listing; detailed dosimetry and efficacy are not verified.",
      "notice": "The merchant title includes slimming, but this build does not claim the belt causes fat or weight loss. Confirm technical and thermal safety documentation.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing.",
      "role": "device",
      "blockedSale": false,
      "aliases": [
        "Red light belt",
        "Red Light Heated Belt"
      ],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "neckflex",
      "handle": "neck-shoulder-ems-muscle-massager",
      "name": "NeckFlex PulsePro EMS Muscle Massage",
      "originalTitle": "NeckFlex PulsePro EMS Muscle Massage",
      "areas": [
        "face",
        "body"
      ],
      "primaryAreas": [
        "body"
      ],
      "goals": [
        "lift",
        "restore"
      ],
      "concernLinks": [
        {
          "concern": "face-neck",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "review",
          "note": "This is a neck/shoulder comfort device, not an anterior-neck lifting device. Confirm exact electrode zones.",
          "role": "tool"
        },
        {
          "concern": "body-recovery",
          "area": "body",
          "goals": [
            "restore"
          ],
          "status": "discover",
          "note": "Neck/shoulder comfort only, used in the exact locations allowed by the model manual.",
          "role": "support"
        }
      ],
      "technology": "Neck and shoulder EMS comfort device",
      "description": "A neck/shoulder massage listing, not a facial-lifting or anterior-neck treatment recommendation.",
      "notice": "Only use on locations explicitly permitted by the actual EMS manual. Do not infer that neck/shoulder positioning permits use on the front of the neck.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "sculptpro",
      "handle": "body-shaping-neck-instrument",
      "name": "SculptPro Ultrasonic Neck Shaper",
      "originalTitle": "SculptPro Ultrasonic Neck Shaper",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "lift"
      ],
      "concernLinks": [
        {
          "concern": "face-neck",
          "area": "face",
          "goals": [
            "lift"
          ],
          "status": "discover",
          "note": "Posture/reminder companion, not a verified neck-lift or drainage treatment.",
          "role": "support"
        }
      ],
      "technology": "Neck posture / reminder wearable",
      "description": "A battery-powered neck wearable whose listing describes posture reminders. Sculpting claims need review.",
      "notice": "Positioned as a posture reminder, not proven lymphatic drainage or body contouring. Confirm the actual mechanism and manual.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": true,
      "cordlessEvidence": "The listing specifies a 350mAh/3.7V battery.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "portablecurler",
      "handle": "portable-hair-curler-straightener",
      "name": "Portable Hair Curler & Straightener",
      "originalTitle": "Portable Hair Curler & Straightener",
      "areas": [
        "hair"
      ],
      "primaryAreas": [
        "hair"
      ],
      "goals": [
        "style"
      ],
      "concernLinks": [
        {
          "concern": "hair-styling",
          "area": "hair",
          "goals": [
            "style"
          ],
          "status": "discover",
          "note": "Hair styling format, not a scalp-growth treatment.",
          "role": "tool"
        }
      ],
      "technology": "Cordless heated styling tool",
      "description": "A portable cordless curler/straightener with adjustable temperature settings.",
      "notice": "Merchant descriptions have not been independently validated. Confirm intended use and compatibility before purchase.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": true,
      "cordlessEvidence": "The merchant explicitly describes it as cordless and lists a battery-level display.",
      "role": "device",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "uvscar",
      "handle": "uv-light-scar-pen-gentle-fade-repair-skin-scar-smooth-skin-light-scar-pen",
      "name": "UV Light Scar Pen",
      "originalTitle": "UV Light Scar Pen",
      "areas": [
        "face"
      ],
      "primaryAreas": [
        "face"
      ],
      "goals": [
        "glow"
      ],
      "concernLinks": [
        {
          "concern": "face-scars",
          "area": "face",
          "goals": [
            "glow"
          ],
          "status": "review",
          "note": "Do not infer that UV exposure safely treats scars. Spectrum, output, intended use and eye/skin safety have not been established for this listing. Disabled for purchase in this prototype pending review.",
          "role": "tool"
        }
      ],
      "technology": "UV scar-pen listing · withheld for safety review",
      "description": "A requested existing listing retained in the review register, not recommended for self-treatment.",
      "notice": "Do not infer that UV exposure safely treats scars. Spectrum, output, intended use and eye/skin safety have not been established for this listing. Disabled for purchase in this prototype pending review.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Cordless operation not established from the inspected listing.",
      "role": "device",
      "blockedSale": true,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "flexrevive",
      "handle": "muscle-roller-stick-body-massage",
      "name": "FlexRevive Muscle Relief Roller",
      "originalTitle": "FlexRevive Muscle Relief Roller",
      "areas": [
        "body"
      ],
      "primaryAreas": [
        "body"
      ],
      "goals": [
        "restore",
        "depuff"
      ],
      "concernLinks": [
        {
          "concern": "body-recovery",
          "area": "body",
          "goals": [
            "restore"
          ],
          "status": "discover",
          "note": "Manual massage and body comfort; not treatment of injury.",
          "role": "support"
        },
        {
          "concern": "body-fascia",
          "area": "body",
          "goals": [
            "restore"
          ],
          "status": "discover",
          "note": "A massage option. Structural fascia-release claims are not verified.",
          "role": "support"
        },
        {
          "concern": "body-lymphatic",
          "area": "body",
          "goals": [
            "depuff"
          ],
          "status": "review",
          "note": "A massage roller is not automatically a lymphatic-drainage treatment; this association needs verification.",
          "role": "tool"
        }
      ],
      "technology": "Manual body massage roller",
      "description": "A manual massage roller for body comfort; not a verified fascia-release or lymph-drainage treatment.",
      "notice": "Merchant descriptions have not been independently validated. Confirm intended use and compatibility before purchase.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Manual tool; no electrical power.",
      "role": "manual",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    },
    {
      "id": "acupoint",
      "handle": "back-acupoint-muscle-relaxation-massage-hook",
      "name": "AcuPoint Muscle Relaxation Massage Hook",
      "originalTitle": "AcuPoint Muscle Relaxation Massage Hook",
      "areas": [
        "body"
      ],
      "primaryAreas": [
        "body"
      ],
      "goals": [
        "restore"
      ],
      "concernLinks": [
        {
          "concern": "body-recovery",
          "area": "body",
          "goals": [
            "restore"
          ],
          "status": "discover",
          "note": "Manual massage and body comfort; not treatment of injury.",
          "role": "support"
        },
        {
          "concern": "body-fascia",
          "area": "body",
          "goals": [
            "restore"
          ],
          "status": "discover",
          "note": "A massage option. Structural fascia-release claims are not verified.",
          "role": "support"
        }
      ],
      "technology": "Manual targeted body massage",
      "description": "A long-handled manual hook for a targeted body-massage routine.",
      "notice": "Merchant descriptions have not been independently validated. Confirm intended use and compatibility before purchase.",
      "frequency": "Follow the actual product manual; no frequency protocol has been independently verified.",
      "cordless": false,
      "cordlessEvidence": "Manual tool; no electrical power.",
      "role": "manual",
      "blockedSale": false,
      "aliases": [],
      "edit": null,
      "bestSellerCollection": false,
      "reviewStatus": "draft",
      "why": "A linked AllureHaul listing relevant to this browsing category; not an independent test verdict."
    }
  ]
};
